export default "__VITE_ASSET__CrZYWLk2__"